import React, { useMemo } from 'react';
import type { ChannelDashboardOverview } from '@troia-v3/types';

import { useChannelMediaList, useChannelMediaSocket } from '../../hooks';
import { FeaturedVideos } from './FeaturedVideos';
import { MediaGallery } from './MediaGallery';
import { PostComposer } from './PostComposer';
import { ScheduledQueue } from './ScheduledQueue';

interface Props {
  channelId: string;
  channel: ChannelDashboardOverview['channel'];
}

export const PostsSection: React.FC<Props> = ({ channelId, channel }) => {
  useChannelMediaSocket(channelId);
  const { data, isLoading } = useChannelMediaList(channelId, { limit: 50 });
  const items = useMemo(() => data?.items ?? [], [data]);

  const published = useMemo(() => items.filter((m) => m.status === 'published'), [items]);
  const queue = useMemo(
    () => items.filter((m) => m.status === 'draft' || m.status === 'scheduled' || m.status === 'failed' || m.status === 'publishing'),
    [items],
  );
  const featured = useMemo(() => published.filter((m) => m.mediaType === 'reels'), [published]);

  return (
    <div data-testid="cdash-posts-section">
      <div className="cdash-sec first">
        <PostComposer channelId={channelId} channel={channel} />
      </div>

      {featured.length > 0 && (
        <div className="cdash-sec">
          <FeaturedVideos items={featured} />
        </div>
      )}

      <div className="cdash-sec">
        <span className="cdash-mlabel">Fila · rascunhos e agendados</span>
        {isLoading ? (
          <div className="cdash-empty"><div className="cdash-empty-t">Carregando…</div></div>
        ) : (
          <ScheduledQueue channelId={channelId} channel={channel} items={queue} />
        )}
      </div>

      <div className="cdash-sec">
        <span className="cdash-mlabel">Publicações</span>
        {isLoading ? <div className="cdash-empty"><div className="cdash-empty-t">Carregando…</div></div> : <MediaGallery items={published} />}
      </div>
    </div>
  );
};
